var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/Notifications.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext } from 'react';
import NotificationsIcon from './NotificationsIcon';
import NotificationsSheet from './NotificationsSheet';
import HeaderContext from '../../HeaderContext';
import useNotificationsCount from './useNotificationsCount';
var Notifications = function Notifications(_ref) {
  var showNotifications = _ref.showNotifications,
    toggleNotifications = _ref.toggleNotifications;
  var _useContext = useContext(HeaderContext),
    pageName = _useContext.pageName,
    pageURL = _useContext.pageURL,
    user = _useContext.user,
    lang = _useContext.lang;
  var userId = user === null || user === void 0 ? void 0 : user.userId;
  var packageId = user === null || user === void 0 ? void 0 : user.packageId;
  var _useNotificationsCoun = useNotificationsCount(showNotifications),
    _useNotificationsCoun2 = _slicedToArray(_useNotificationsCoun, 2),
    notificationsCount = _useNotificationsCoun2[0],
    fetchNotifications = _useNotificationsCoun2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationsIcon, {
    unreadNotificationsCount: notificationsCount,
    toggleNotifications: toggleNotifications,
    showNotifications: showNotifications,
    pageName: pageName,
    pageURL: pageURL,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(NotificationsSheet, {
    unreadNotificationsCount: notificationsCount,
    toggleNotifications: toggleNotifications,
    showNotifications: showNotifications,
    pageName: pageName,
    pageURL: pageURL,
    refetchNotificationIconCount: fetchNotifications,
    userId: userId,
    packageId: packageId,
    lang: lang,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }));
};
export default Notifications;
export { Notifications };
//# sourceMappingURL=Notifications.js.map